import { render, staticRenderFns } from "./ProgramTDCEvaluation.vue?vue&type=template&id=b55ba9d8"
import script from "./ProgramTDCEvaluation.vue?vue&type=script&lang=js"
export * from "./ProgramTDCEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports